import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './services/theme.service';
import { AppTheme } from './types/app.types';
import { Meta } from "@angular/platform-browser";
import { environment } from "../environments/environment";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  #themeService = inject(ThemeService);
  #metaService = inject(Meta);

  constructor() {
    const savedTheme = localStorage.getItem('theme') as AppTheme | null;

    if (savedTheme) {
      this.#themeService.setTheme(savedTheme);
      this.#themeService.isDark.set(savedTheme === 'dark');
    } else {
      const currentTheme = this.#themeService.getTheme();
      localStorage.setItem('theme', currentTheme);
      this.#themeService.isDark.set(currentTheme === 'dark');
    }

    // Set the initial state of the chat bubble stacking based on localStorage
    const stackedChatBubbles = localStorage.getItem('chatStack');
    this.#themeService.setChatBubbleStacked(stackedChatBubbles === 'true');
  }

  ngOnInit() {
    this.#metaService.addTag({ rel: 'preconnect', href: environment.msalConfig.auth.redirectUri });
  }
}
